import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { RequestService } from 'src/app/services/request/request.service';
import Swal2 from 'sweetalert2';
import { ModalController } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { Bienes6Component } from 'src/app/components/publication/create/bienes/bienes6/bienes6.component';
import { SeguridadComponent } from 'src/app/components/general-design/seguridad/seguridad.component';
import { Capacitor } from '@capacitor/core';
import{FingerprintAIO}from "@ionic-native/fingerprint-aio/ngx";
import { PagoVerificacionComponent } from 'src/app/components/pago-verificacion/pago-verificacion.component';
@Component({
  selector: 'app-alibaba-checkout-cart',
  templateUrl: './alibaba-checkout-cart.component.html',
  styleUrls: ['./alibaba-checkout-cart.component.scss'],
})

export class AlibabaCheckoutCartComponent implements OnInit, OnDestroy {
  shippingOptions = [
  
  ];
    @Input() just_opening_cart
  isExpanded = false; // Initially, details are hidden
  tax;
  selectionOption;
  name?: string;
  postal_code?: string;
  calle?: string;
  Ciudad?: string;
  Estado?: string;
  country?: string;
  rfc?: string;
  mail?: string;
  phone_country?: string;
  mobile_no?: string;
  address;
  @Input() cart: any[] = [];
  TotalPayment =0;
  shipping_cost:number=0;
  selectedShippingOption: any = null;
  @Input() product_name;
  metodoPagoSeleccionado='wallet';
  paymentMethodSelection: 'saved_card' | 'other' = 'other';
  hasSavedStripeCard = false;
  savedStripeCard: any = null;
  savedStripeCardLoading = false;
  reservationCountdown: string | null = null;
  reservationProgress = 0;
  reservationEndsAtLabel: string | null = null;
  private reservationInterval: ReturnType<typeof setInterval> | null = null;
  constructor(   
    public formservice:FormServiceService,
    private request: RequestService,
    private modalController: ModalController,
    private route: ActivatedRoute,
    private router:Router,
    private location: Location,
        	private faio:FingerprintAIO,
  ) { }


  async open_address_component(){
    const modal = await this.modalController.create({
canDismiss: true,
      component: Bienes6Component,
      componentProps: {
        show_save_address_button: true,
      },
      cssClass: 'my-custom-modal', // Optional: custom styling class
    });

    await modal.present();

    // Listen for modal dismissal
    const { data } = await modal.onDidDismiss();

    // Assign address data from formservice
    this.name = this.formservice?.feexpublication?.name;
    this.postal_code = this.formservice.feexpublication.postal_code;
    this.calle = this.formservice.feexpublication.calle;
    this.Ciudad = this.formservice.feexpublication.Ciudad;
    this.Estado = this.formservice.feexpublication.Estado;
    this.country = this.formservice.feexpublication.country;
    this.rfc = this.formservice.feexpublication.rfc;
    this.mail = this.formservice.feexpublication.mail;
    this.phone_country = this.formservice.feexpublication.lada;
    this.mobile_no = this.formservice.feexpublication.celular;

    let address = {
      name: this.name,
      postal_code: this.postal_code,
      calle: this.calle,
      Ciudad: this.Ciudad,
      Estado: this.Estado,
      country: this.country,
      rfc: this.rfc,
      mail: this.mail,
      phone_country: this.phone_country,
      mobile_no: this.mobile_no,
    };

    this.address = address;
    this.called_freight_fetch = false;
    this.fetch_freight();
  }
  ngOnInit() {
    this.applyQueryParams();
    this.updateReservationPresentation();
    this.reservationInterval = setInterval(() => this.updateReservationPresentation(), 1000);
    this.loadDefaultSavedPaymentMethod();
    if(!this.formservice.profile){
       this.fetch_freight();

    }
    this.only_one_product_on_the_cart = this.cart?.length > 0;
   
    this.request.createRequestPost('ShippingAddressesController', {get:true })
    .then((data) => {
      console.log('fetching address',data)
      if (data && typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
      }
      if(!data.title){
      this.open_address_component();
      return;
      }
      console.log('ShippingAddressesController',data);
     this.address=data.title;
     this.name=data.title.name;
     this.postal_code=data.title.postal_code;
     this.calle=data.title.calle;
     this.Ciudad=data.title.Ciudad;
     this.Estado=data.title.Estado;
     this.country=data.title.country;
     this.rfc=data.title.rfc;
     // ShippingAddressesController stores the field as `email`; older
     // checkout snapshots use the legacy `mail` name.
     this.mail=data.title.mail || data.title.email;
     this.phone_country=data.title.phone_country;
     
     this.mobile_no=data.title.mobile_no;
     this.address = { ...data.title, mail: this.mail };
    this.fetch_freight();
    });

  }

  private applyQueryParams(): void {
    const cartParam = this.route.snapshot.queryParamMap.get('cart');
    const productName = this.route.snapshot.queryParamMap.get('product_name');
    const justOpeningCart = this.route.snapshot.queryParamMap.get('just_opening_cart');

    if (productName) {
      this.product_name = productName;
    }

    if (justOpeningCart !== null) {
      this.just_opening_cart = justOpeningCart === 'true' || justOpeningCart === '1';
    }

    if (!cartParam) {
      return;
    }

    try {
      const parsedCart = JSON.parse(cartParam);
      if (Array.isArray(parsedCart)) {
        this.cart = parsedCart;
        this.formservice.AlibabaCheckoutCart = parsedCart;
      }
    } catch (error) {
      console.error('[AlibabaCheckoutCart] Could not parse cart query param.', error);
    }
  }

  ngOnDestroy(): void {
    if (this.reservationInterval) {
      clearInterval(this.reservationInterval);
      this.reservationInterval = null;
    }
  }

  private normalizeResponse(data: any): any {
    if (data && typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (error) {
        console.error("Error parsing data:", error);
        return null;
      }
    }
    return data;
  }

  private loadDefaultSavedPaymentMethod(): void {
    this.paymentMethodSelection = 'other';
    this.metodoPagoSeleccionado = 'wallet';
    this.hasSavedStripeCard = false;
    this.savedStripeCard = null;

    if (!this.formservice.profile) {
      return;
    }

    this.savedStripeCardLoading = true;
    this.request.createRequestPost('get_stripe_default_saved_payment_method', {})
      .then((data) => {
        data = this.normalizeResponse(data);
        console.log('get_stripe_default_saved_payment_method:', data);
        if (data?.ok && data?.data) {
          this.hasSavedStripeCard = true;
          this.savedStripeCard = data.data;
          this.paymentMethodSelection = 'saved_card';
          this.metodoPagoSeleccionado = 'tarjeta guardada';
        }
      })
      .catch((error) => {
        console.error('Failed to load default saved payment method:', error);
      })
      .finally(() => {
        this.savedStripeCardLoading = false;
      });
  }

  private updateReservationPresentation(): void {
    const expiresAt = this.formservice.dsReservationExpiresAt;
    if (!expiresAt) {
      this.reservationCountdown = null;
      this.reservationProgress = 0;
      this.reservationEndsAtLabel = null;
      return;
    }

    const remainingMs = expiresAt - Date.now();
    if (remainingMs <= 0) {
      this.formservice.dsReservationExpiresAt = null;
      this.reservationCountdown = null;
      this.reservationProgress = 0;
      this.reservationEndsAtLabel = null;
      return;
    }

    const totalSeconds = Math.floor(remainingMs / 1000);
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
    const seconds = (totalSeconds % 60).toString().padStart(2, '0');
    this.reservationCountdown = `${hours}:${minutes}:${seconds}`;
    this.reservationProgress = Math.max(0, Math.min(100, (remainingMs / this.formservice.dsReservationDurationMs) * 100));
    this.reservationEndsAtLabel = new Date(expiresAt).toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      month: 'short',
      day: 'numeric',
    });
  }
  called_freight_fetch;
  fetch_freight(){
    if(this.called_freight_fetch){
      return;
    }
    this.called_freight_fetch=true;
    const freightQueryItems = this.only_one_product_on_the_cart && this.cart?.length > 0
      ? [{
          ...this.cart[0],
          selectedQuantity: this.cart.reduce(
            (total, item) => total + Number(item?.selectedQuantity ?? 0),
            0
          ),
        }]
      : this.cart;

    const freightRequests = freightQueryItems.map((item) => {
      console.log('fetching freight');
      return this.request.createRequestPost('AlibabaProductHandler', {
        freight_query: true,
        cart: item,
        cityCode: this.Ciudad,
        provinceCode: this.Estado
      }).then((data) => {
        if (data && typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error("Error parsing data:", error);
          }
        }
        console.log('Response for item:', item, data);
        const options =
          data?.success?.aliexpress_ds_freight_query_response?.result?.delivery_options?.delivery_option_d_t_o
          ?? data?.aliexpress_ds_freight_query_response?.result?.delivery_options?.delivery_option_d_t_o
          ?? data?.success?.result?.delivery_options?.delivery_option_d_t_o
          ?? data?.result?.delivery_options?.delivery_option_d_t_o
          ?? data?.delivery_options?.delivery_option_d_t_o
          ?? data?.options
          ?? [];
        if (!Array.isArray(options) || options.length === 0) {
          console.warn('No shipping options found for item response shape:', { item, data });
        }
        return {
          item,
          options: this.normalizeAliExpressShippingOptions(options),
        };
      }).catch((error) => {
        console.error('Error for item:', item, error);
        return {
          item,
          options: [],
        };
      });
    });

    Promise.all(freightRequests).then((responses) => {
      const validResponses = responses.filter((response) => Array.isArray(response.options) && response.options.length > 0);
      if (validResponses.length === 0) {
        this.shippingOptions = [];
        return;
      }

      if (this.only_one_product_on_the_cart) {
        const sortedResponsesByQty = [...validResponses].sort((a, b) => {
          const qtyA = Number(a?.item?.selectedQuantity ?? 0);
          const qtyB = Number(b?.item?.selectedQuantity ?? 0);
          return qtyB - qtyA;
        });
        const responseWithHighestQty = sortedResponsesByQty[0];

        const baselineFeesByCode = new Map<string, number>();
        (responseWithHighestQty?.options ?? []).forEach((option) => {
          baselineFeesByCode.set(option.code, Number(option.shipping_fee_cent ?? 0));
        });

        let hasFeeVariation = false;
        for (const response of validResponses) {
          for (const option of response.options) {
            const baselineFee = baselineFeesByCode.get(option.code);
            const currentFee = Number(option.shipping_fee_cent ?? 0);
            if (baselineFee === undefined || baselineFee !== currentFee) {
              hasFeeVariation = true;
              break;
            }
          }
          if (hasFeeVariation) {
            break;
          }
        }

        if (!hasFeeVariation) {
          this.shippingOptions = responseWithHighestQty?.options ?? [];
          return;
        }

        const optionTotalsByCode = new Map<string, any>();
        const optionPresenceCountByCode = new Map<string, number>();
        validResponses.forEach((response) => {
          const seenCodes = new Set<string>();
          response.options.forEach((option) => {
            const code = option.code;
            const currentFee = Number(option.shipping_fee_cent ?? 0);
            const existingOption = optionTotalsByCode.get(code);

            if (!existingOption) {
              optionTotalsByCode.set(code, {
                ...option,
                shipping_fee_cent: currentFee,
              });
            } else {
              existingOption.shipping_fee_cent = Number(existingOption.shipping_fee_cent ?? 0) + currentFee;
            }

            if (!seenCodes.has(code)) {
              optionPresenceCountByCode.set(code, Number(optionPresenceCountByCode.get(code) ?? 0) + 1);
              seenCodes.add(code);
            }
          });
        });

        const requiredPresence = validResponses.length;
        this.shippingOptions = Array.from(optionTotalsByCode.values()).filter(
          (option) => Number(optionPresenceCountByCode.get(option.code) ?? 0) === requiredPresence
        );

        if (this.shippingOptions.length === 0) {
          this.shippingOptions = responseWithHighestQty?.options ?? [];
        }
        return;
      }

      const cheapestOptionPerItem = validResponses.map((response) => {
        const responseOptions = response.options ?? [];
        return responseOptions.reduce((cheapestOption, currentOption) => {
          const currentFee = Number(currentOption?.shipping_fee_cent ?? 0);
          const cheapestFee = Number(cheapestOption?.shipping_fee_cent ?? 0);
          return currentFee < cheapestFee ? currentOption : cheapestOption;
        }, responseOptions[0]);
      }).filter((option) => !!option);

      if (cheapestOptionPerItem.length > 0) {
        const totalShippingFeeCent = cheapestOptionPerItem.reduce(
          (total, option) => total + Number(option?.shipping_fee_cent ?? 0),
          0
        );

        const baseOption = cheapestOptionPerItem[0];
        this.shippingOptions = [{
          ...baseOption,
          code: 'CHEAPEST_COMBINED_OPTION',
          shipping_fee_cent: totalShippingFeeCent,
          free_shipping: totalShippingFeeCent === 0,
          delivery_date_desc: 'Cheapest combined shipping option',
        }];
        return;
      }

      this.shippingOptions = validResponses[validResponses.length - 1].options ?? [];
    });
  }
  only_one_product_on_the_cart:boolean=false;

  private getAliExpressShippingOptionCode(option: any): string | null {
    const candidates = [
      option?.logistics_service_name,
      option?.logisticsServiceName,
      option?.delivery_option_code,
      option?.deliveryOptionCode,
      option?.delivery_method_code,
      option?.deliveryMethodCode,
      option?.shipping_method,
      option?.shippingMethod,
      option?.code,
      option?.service_name,
      option?.serviceName,
    ];

    for (const candidate of candidates) {
      if (typeof candidate !== 'string' || !candidate.trim()) {
        continue;
      }

      const code = candidate.trim();
      if (code.toUpperCase() === 'CHEAPEST_COMBINED_OPTION') {
        return null;
      }
      return code;
    }

    return null;
  }

  private normalizeAliExpressShippingOptions(options: any): any[] {
    const source = Array.isArray(options)
      ? options
      : (options && typeof options === 'object' ? [options] : []);

    return source.reduce((normalized: any[], option: any) => {
      if (!option || typeof option !== 'object') {
        return normalized;
      }

      const code = this.getAliExpressShippingOptionCode(option);
      if (!code) {
        return normalized;
      }

      normalized.push({ ...option, code });
      return normalized;
    }, []);
  }

  private getSelectedAliExpressShippingMethod(): string | null {
    const candidates = [
      this.selectedShippingOption?.logistics_service_name,
      this.selectedShippingOption?.logisticsServiceName,
      this.selectedShippingOption?.delivery_option_code,
      this.selectedShippingOption?.deliveryOptionCode,
      this.selectedShippingOption?.delivery_method_code,
      this.selectedShippingOption?.deliveryMethodCode,
      this.selectedShippingOption?.code,
      typeof this.selectionOption === 'string' ? this.selectionOption : null,
    ];

    for (const candidate of candidates) {
      if (typeof candidate !== 'string' || !candidate.trim()) {
        continue;
      }

      const method = candidate.trim();
      if (method.toUpperCase() === 'CHEAPEST_COMBINED_OPTION') {
        return null;
      }
      return method;
    }

    return null;
  }

  private getAliExpressCheckoutItems(): any[] {
    const logisticsService = this.getSelectedAliExpressShippingMethod();
    const items = Array.isArray(this.cart) ? this.cart : [];

    return items.map((item) => {
      const checkoutItem = { ...(item || {}) };
      if (logisticsService) {
        // Keep both names for compatibility with the current and legacy
        // checkout payloads. The backend maps the value to AliExpress's
        // required logistics_service_name field.
        checkoutItem.logistics_service_name = logisticsService;
        checkoutItem.shipping_method = logisticsService;
      }
      return checkoutItem;
    });
  }

  private async closeTopModals(count: number): Promise<void> {
    for (let i = 0; i < count; i++) {
      const topModal = await this.modalController.getTop();
      if (!topModal) {
        break;
      }
      await topModal.dismiss();
    }
  }

  ngAfterViewInit(){
    console.log('cart', this.cart);
    if(this.cart?.length ==0){
       this.cart=this.formservice.AlibabaCheckoutCart;
      if(!this.just_opening_cart){
this.request.createRequestPost('ControladorDeCarritoDeCompras', {update_cart:true,add_items:true, cart_items: this.cart})
      .then((data) => {
        if (data && typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error("Error parsing data:", error);
          }
        }
        console.log('data',data);
        Swal2.fire({
          title: 'Cart updated',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
          text: 'Your cart has been updated successfully.',
          icon: 'success',
          confirmButtonText: 'OK',
          color: '#ffffff',
          background: '#010f4e',
        });
        this.router.navigateByUrl('/feex-wholesale').then(() => {
          this.closeTopModals(3);
        });
  
     
      });
      }
     
      
    }else{
      this.only_one_product_on_the_cart=true;
    //nothing as they just want to buy a product inmediatley
    }

    
    

  }

  getCartUnits(): number {
    return this.cart?.reduce((total, item) => total + Number(item?.selectedQuantity || 0), 0) || 0;
  }

  getCartSubtotalRaw(): number {
    return this.cart?.reduce(
      (total, item) => total + Number(item?.price || 0) * Number(item?.selectedQuantity || 0),
      0
    ) || 0;
  }

  formatMoney(value: any): string {
    return Number(value || 0).toLocaleString('es-MX', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  async openPremiumVerification(): Promise<void> {
    const profile = this.formservice?.profile;

    if (!profile) {
      Swal2.fire({
        title: 'Inicia sesión',
        text: 'Necesitas iniciar sesión para activar Premium.',
        icon: 'info',
        timer: 4200,
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        background: '#010f4e',
        color: '#ffffff',
      });
      this.router.navigate(['/login']);
      return;
    }

    if (profile?.kyc === 'Validado') {
      Swal2.fire({
        title: 'Premium activo',
        text: 'Tu perfil ya está verificado.',
        icon: 'success',
        timer: 3600,
        timerProgressBar: true,
        toast: true,
        position: 'top-start',
        showConfirmButton: false,
        background: '#010f4e',
        color: '#ffffff',
      });
      return;
    }

    const modal = await this.modalController.create({
      component: PagoVerificacionComponent,
      cssClass: 'detailsInModal',
      canDismiss: true,
      componentProps: {
        pr: profile,
      },
    });
    await modal.present();
  }

  // Calculate the total price of the cart
  calculateTotal(): number {
     this.TotalPayment= this.cart.reduce(
      (total, item) => total + item.price * item.selectedQuantity,
      0
    );
    this.tax =this.TotalPayment + this.shipping_cost;
    this.tax=Math.round(this.tax *  this.formservice.DS_fee);



    this.TotalPayment= Math.round(this.TotalPayment+this.shipping_cost +this.tax );

    return this.TotalPayment;
  }

  // Checkout logic
  checkout(): void {
    console.log('checkout called')
    if(!this?.name || !this.postal_code || !this.calle || !this.Ciudad || !this.Estado || !this.country){
      Swal2.fire({
        title: 'Error',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        text: 'A problem occurred while processing your request. Please add a shipping address.',
        icon: 'error',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }else{
      console.log('data missing')
    }
    if(!this.selectionOption){
      Swal2.fire({
        title: 'Error',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        text: 'A problem occurred while processing your request. Please select a shipping option.',
        icon: 'error',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }
    if(!this.mobile_no){
      Swal2.fire({
        title: 'Error',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
        text: 'A problem occurred while processing your request. Please add a mobile number in "Add new address".',
        icon: 'error',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
      return;
    }

     if(this.formservice.profile && this.paymentMethodSelection === 'saved_card' && this.hasSavedStripeCard){
        this.handled_logged_in_user();
      }else{
    this.seleccionarMetodoPago();
      }
    /*
    console.log('Checkout:', this.cart);
    this.request.createRequestPost('AlibabaProductHandler', { create_order_and_pay: true, cart: this.cart })
    .then((data) => {
      console.log('data', data);
      Swal2.fire({
        title: 'Purchase completed successfully',
        text: 'Tu orden ha sido creada y procesada correctamente. Gracias por tu compra.',
        icon: 'success',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
    })
    .catch((error) => {
      console.error('Error occurred:', error);
      Swal2.fire({
        title: 'Error',
        text: 'A problem occurred while processing your request. Please try again later.',
        icon: 'error',
        confirmButtonText: 'Understood',
        color: '#ffffff',
        background: '#010f4e',
      });
    });
    */
  
    // Logic to handle checkout process, e.g., API call or navigation
  }
  removeItem(item){
    this.request.createRequestPost('ControladorDeCarritoDeCompras', {update_cart:true,delete_items:true, item: item})
    .then((data) => {
      console.log('data',data);
      this.request.createRequestPost('ControladorDeCarritoDeCompras', {update_cart:true,get_items:true, })
      .then((data) => {
        if (data && typeof data === 'string') {
          try {
            data = JSON.parse(data);
            console.log('getRecordByToken ios:',data);
          } catch (error) {
            console.error("Error parsing data:", error);
          }
          }
        console.log('data',data);
        this.cart=data.cart_items;
        this.formservice.AlibabaCheckoutCart=this.cart;
  
     
      });
   
    });
  }
  toggleAddressDetails() {
    this.isExpanded = !this.isExpanded;
  }
  seleccionarMetodoPago(){
    const address = {
      name: this.name,
      postal_code: this.postal_code,
      calle: this.calle,
      Ciudad: this.Ciudad,
      Estado: this.Estado,
      country: this.country,
      rfc: this.rfc,
      mail: this.mail,
      phone_country: this.phone_country,
      mobile_no: this.mobile_no
    };
    const checkoutItems = this.getAliExpressCheckoutItems();
    const product_id = checkoutItems?.[0]?.product_id;
    const sing_or_multi_product = this.only_one_product_on_the_cart ? 'sing' : 'multi';
    const objmedia = {
      sing_or_multi_product: sing_or_multi_product,
      publication_type: 'Alibaba',
      address: address,
      item: checkoutItems,
      costo_total: this.TotalPayment,
      costo_de_envio: this.shipping_cost,
      product_id: product_id, // used for Payment Controller web hooks only
      shipping_method: this.getSelectedAliExpressShippingMethod(),
      shipping_option: this.selectedShippingOption,
    };

    this.formservice.AlibabaCheckoutCart = this.cart;
    // A fresh token makes same-route navigation observable in retained native
    // WebViews. The wallet uses the latest session payload for this checkout.
    const checkoutContext = `${Date.now()}-${product_id || 'feex-cart'}`;
    const walletCheckoutState = {
      shortcut: 'pagoDePublicacion',
      objmedia: objmedia,
      TotalPayment: this.TotalPayment,
      publication_id: product_id,
      checkout_context: checkoutContext
    };
    try {
      sessionStorage.setItem('AlibabaWalletCheckoutState', JSON.stringify(walletCheckoutState));
    } catch (error) {
      console.error('Could not persist Alibaba wallet checkout state:', error);
    }
    this.router.navigate(['/home/ecosystem-page/wallet'], {
      queryParams: {
        shortcut: 'pagoDePublicacion',
        TotalPayment: this.TotalPayment,
        publication_id: product_id,
        checkout_context: checkoutContext
      },
      state: walletCheckoutState
    });
  }
  onShippingOptionChange(selectedCode: string) {
    const selectedOption = this.shippingOptions.find(option => option.code === selectedCode);
    this.selectedShippingOption = selectedOption || null;
    if (selectedOption) {
      this.shipping_cost = Number(selectedOption.shipping_fee_cent ?? 0) ?? 0; 
    }
  }
  async dismiss(){
    const topModal = await this.modalController.getTop();
    if (topModal) {
      await topModal.dismiss();
      return;
    }

    this.location.back();
  }
  async handleShippingAddressClick() {
    const modal = await this.modalController.create({
canDismiss: true,
      component: Bienes6Component,
      componentProps: {
        show_save_address_button: true,
      },
      cssClass: 'my-custom-modal',
    });
  
    await modal.present();
  
    // Listen for modal dismissal
    const { data } = await modal.onDidDismiss();

    this.name=this.formservice?.feexpublication?.name;
    this.postal_code=this.formservice.feexpublication.postal_code;
    this.calle=this.formservice.feexpublication.calle;
    this.Ciudad=this.formservice.feexpublication.Ciudad;
    this.Estado=this.formservice.feexpublication.Estado;
    this.country=this.formservice.feexpublication.country;
    this.rfc=this.formservice.feexpublication.rfc;
    this.mail=this.formservice.feexpublication.mail;
    this.phone_country=this.formservice.feexpublication.lada;
    this.mobile_no=this.formservice.feexpublication.celular;
    let address ={
      name:this.name,
      postal_code:this.postal_code,
      calle:this.calle,
      Ciudad:this.Ciudad,
      Estado:this.Estado,
      country:this.country,
      rfc:this.rfc,
      mail:this.mail,
      phone_country:this.phone_country,
      mobile_no:this.mobile_no

    }
    this.address=address;
    console.log(' .address', this.address)
    // Handle the dismissal event
    if (data) {
      console.log('Popover dismissed with data:', data);
      // Add your logic here to handle the data returned from the popover


     
    } else {
      console.log('Popover dismissed without data');
    }
  }
  
 stripe_pay(){

      let address ={
        name:this.name,
        postal_code:this.postal_code,
        calle:this.calle,
        Ciudad:this.Ciudad,
        Estado:this.Estado,
        country:this.country,
        rfc:this.rfc,
        mail:this.mail,
        phone_country:this.phone_country,
        mobile_no:this.mobile_no

      }
      const checkoutItems = this.getAliExpressCheckoutItems();
      // Extract product_id from the first item in the array
let product_id = checkoutItems?.[0]?.product_id;
console.log('product_id', product_id);
let sing_or_multi_product= 'sing';
if(this.only_one_product_on_the_cart){
sing_or_multi_product= 'sing';
}else{
sing_or_multi_product= 'multi';
}
console.log('product_id', product_id); // Outputs the product_id if available
      let objmedia = {
        sing_or_multi_product:sing_or_multi_product,
        publication_type:'Alibaba',
        address:address,
        item:checkoutItems,
        costo_total:this.TotalPayment,
        costo_de_envio:this.shipping_cost,
        product_id:product_id, // used for Payment Controller web hooks only
        shipping_method: this.getSelectedAliExpressShippingMethod(),
        shipping_option: this.selectedShippingOption,
      }
    let object={
          objmedia:objmedia,
          publication_id:product_id,     
            amount:this.TotalPayment,
            currency:'mxn',
            description:"Validacion",
          
           // profile_id: this.profile_id  // Pass the profile id
          }
    this.request.createRequestPost('AliPayChargeSavedStripeCard', {object} ) .then((data) => {
  if (data && typeof data === 'string') {
    try {
      data = JSON.parse(data);
      console.log('getRecordByToken ios:',data);
    } catch (error) {
      console.error("Error parsing data:", error);
    }
    }else{
      console.log('getRecordByToken ios:',data);
    }

    if(data.payment_intent){

                      Swal2.fire({
                            title: 'Success',
                            text: `payment processed successfully`,
                            icon: 'success',
                            timer: 6900, // Show the alert for 6.9 seconds
                            timerProgressBar: true,
                            toast: true,
                          
                       });
                       
                      this.order_ali_products(objmedia,data)

    }else{
            Swal2.fire({
            title: 'error',
            text: `payment not processed successfully`,
            icon: 'success',
            timer: 6900, // Show the alert for 6.9 seconds
            timerProgressBar: true,
            toast: true,
          
  });
    }
  });
  }
order_ali_products(objmedia, parsedResult){
     this.request.createRequestPost('ControladorDeCarritoDeCompras', {
       create_order_and_pay: true,
       cart: objmedia.item,
       objmedia: objmedia,
       order_id: parsedResult.order_id
     })
                  .then((data) => {
                    if (data && typeof data === 'string') {
                      try {
                        data = JSON.parse(data);
                        console.log('getRecordByToken ios:',data);
                      } catch (error) {
                        console.error("Error parsing data:", error);
                      }
                      }
                    console.log('data', data);
                    Swal2.fire({
                      title: 'Purchase completed successfully',
                      text: 'Tu orden ha sido creada y procesada correctamente. Gracias por tu compra.',
                      icon: 'success',
                      confirmButtonText: 'Understood',
                      color: '#ffffff',
                      background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
                    });
                  })
                  .catch((error) => {
                    console.error('Error occurred:', error);
                    Swal2.fire({
                      title: 'Error',
                      text: 'A problem occurred while processing your request. Please try again later.',
                      icon: 'error',
                      confirmButtonText: 'Understood',
                      color: '#ffffff',
                      background: '#010f4e',
            position: 'top-end',
            timerProgressBar: true,
            toast: true,
                    });
                  });
}


private openPaymentWalletFallback(message = 'We could not load your saved card. Please choose another payment method.'): void {
  Swal2.fire({
    title: 'Payment method needed',
    text: message,
    icon: 'info',
    timer: 6900,
    timerProgressBar: true,
    toast: true,
    color: '#ffffff',
    background: '#010f4e',
    position: 'top-end',
  });
  this.seleccionarMetodoPago();
}

async handled_logged_in_user(){
  if (this.savedStripeCard) {
    this.handle_saved_card({ ok: true, data: this.savedStripeCard });
    return;
  }

       this.request.createRequestPost('get_stripe_default_saved_payment_method', {} ) .then((data) => {
                        data = this.normalizeResponse(data);
                        console.log('getRecordByToken ios:',data);
                          if(data?.ok && data?.data){
    this.hasSavedStripeCard = true;
    this.savedStripeCard = data.data;
    this.paymentMethodSelection = 'saved_card';
    this.metodoPagoSeleccionado = 'tarjeta guardada';
    this.handle_saved_card(data);
    
                          }else{
                              this.hasSavedStripeCard = false;
                              this.savedStripeCard = null;
                              this.paymentMethodSelection = 'other';
                              this.metodoPagoSeleccionado = 'wallet';
                              this.openPaymentWalletFallback('A card has not been saved for future use. Please choose another payment method.');
                          }
                        }).catch((error) => {
                          console.error('Failed to send request:', error);
                          this.hasSavedStripeCard = false;
                          this.savedStripeCard = null;
                          this.paymentMethodSelection = 'other';
                          this.metodoPagoSeleccionado = 'wallet';
                          this.openPaymentWalletFallback('No default saved card could be loaded. Please choose another payment method in your wallet.');
                        });
        
}
async handle_saved_card(data){
     let card=data.data;
                              Swal2.fire({
                                  title: 'Card fetched successfully',
                                  text: `The card has been saved for future use.`,
                                  icon: 'success',
                                  timer: 6900, // Show the alert for 6.9 seconds
                                  timerProgressBar: true,
                                  toast: true,
                                
                                });

                                 const end   = card?.last4 ?? '••••';
  const brand = (card?.brand || 'Card').toUpperCase();
  const label = `${brand} •••• ${end}`;

  const result = await Swal2.fire({
    title: 'Pay with saved card?',
    html: `Saved card: <b>${label}</b>.<br>Do you want to pay with this card now?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: `Pay with •••• ${end}`,
    cancelButtonText: 'choose a different payment method.',
    reverseButtons: true,
    focusConfirm: true
  });
  if (result.isConfirmed) {

    if (Capacitor.getPlatform() === 'web') {
      /*
              this.modalController.create({
                component: SeguridadComponent,
                cssClass: 'detailsInModal',
                canDismiss: true, // (forced globally for swipe close on all modals)
                componentProps: {
                  face_id: true,
                }
              }).then((modal) => {
                modal.onDidDismiss().then((data) => {
                  console.log('Modal dismissed:', data);
                  if (data.data.role == 'success' ) {
                    console.log('Output data:', data.role);
                    // Handle the output data from the modal here
          
                  }
                });
                modal.present();
                 // Listen to the output when the modal is dismissed
            
              }).catch((error) => {
                console.error(error);
              });
              */
      
          this.stripe_pay();
      }else{
          this.faio.show({
            title:"Leyendo huella Digital",
            subtitle:"Use su huella para permitir el acceso a retiros",
          
            }).then((res)=>{
          
            console.log(res);
    
            this.stripe_pay();
          
            }).catch((err)=>{
            console.log(err);
      
            alert('Acceso denegado')
          
            })
      }
                          }else{
    this.seleccionarMetodoPago();
                          }
    
}
}
